module.exports = __webpack_public_path__ + "img/quit_icon.0e8ec421.svg";